import Axios from "@/plugins/Axios";

class SalaDeSituacaoService {
  async listarSalaDeSituacao() {
    const response = await Axios().get("salaDeSituacao/listar-turmas");
    return response.data;
  }
}

export default new SalaDeSituacaoService();
